import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import style from './BoxContent.module.scss'
import HoverBlock from './hoverBlock/HoverBlock';
import { NavLink } from 'react-router-dom';
import SkeletonContent from '../../preloader/SceletonContent';
import { setSearch } from '../../../redux/headerSlices/HeaderSlices';
import { setFetching } from '../../../redux/contentSlices/ContentSlices'
import { fetchMovies, fetchUpdateMovies } from '../../../redux/contentSlices/asyncActions'
import { selectContent } from '../../../redux/contentSlices/ContentSelector'
import { selectFilter } from '../../../redux/filterSlices/FilterSelector'
import { selectHeader } from '../../../redux/headerSlices/HeaderSelector'
import { useAppDispatch } from '../../../redux/Store';
import useWhyDidYouUpdate from 'ahooks/lib/useWhyDidYouUpdate';

let BoxContent = React.memo(() => {

    const dispatch = useAppDispatch()

    const { type, sortingBy, minRating, ordering } = useSelector(selectFilter)

    const { search } = useSelector(selectHeader)

    const { homePage, totalCount, content, status, fetching } = useSelector(selectContent)

    useWhyDidYouUpdate('BoxContent', { type, sortingBy, minRating, ordering, homePage, totalCount, content, status, fetching, search })

    useEffect(() => {
        if (fetching) {
            try {
                dispatch(fetchUpdateMovies({ type, minRating, sortingBy, ordering, search, homePage }))
            } catch {
                alert('An error has occurred, the start page will be loaded')
                dispatch(fetchMovies({ type, minRating, sortingBy, ordering, search }))
            }
        }
    }, [fetching]);

    useEffect(() => {
        document.addEventListener('scroll', ScrollHandler)
        return function () {
            document.removeEventListener('scroll', ScrollHandler)
        }
    }, [totalCount])

    const ScrollHandler = (e: any) => {
        if (e.target.documentElement.scrollHeight - (e.target.documentElement.scrollTop + window.innerHeight) < 100 && content.length < totalCount) (
            dispatch(setFetching(true))
        )
    }

    const Skeleton = [...new Array(12)].map((el) => <SkeletonContent />)

    return (
        <div className={style.Box__content}>
            {status === 'completed' ? content.map((el) =>
                <div className={style.content__block} data-testid='movie'>
                    <HoverBlock id={el.id} rating={el.rating} mpa_rating={el.mpa_rating} runtime={el.runtime} genres={el.genres} />
                    <img src={el.large_cover_image} className={style.movie__img} alt='The image is missing' />
                    <div className={style.movie__info}>
                        <NavLink to={`/movieDetails/${el.id}`} onClick={e => dispatch(setSearch(''))}><span className={style.info__title}>{el.title}</span></NavLink >
                        <span className={style.info__subtitle}>{el.year}</span>
                    </div>
                </div>
            ) : Skeleton}
        </div>
    )
})

export default BoxContent;

